import { useNavigate } from "react-router-dom";

/**
 * Hook to handle exiting the settings page.
 * This needs to be called from a component at the app level that's always mounted,
 * not just when settings is active, so it can track the last non-settings page.
 */
export const useExitSettings = () => {
  const navigate = useNavigate();

  const handleExitSettings = () => {
    // Check if there's history and if we can go back
    if (window.history.state && window.history.length > 1) {
      const historyState = window.history.state as { idx?: number };

      // If we have valid history, go back
      if (historyState?.idx !== undefined && historyState.idx > 0) {
        void navigate(-1);
        return;
      }
    }

    // Default to home if no valid history
    void navigate("/");
  };

  return handleExitSettings;
};
